import React from "react";
import { object } from "prop-types";
import get from "lodash/get";

import Organism1 from "../FourCollection12Stories/Organism1/index";

import "./fourCollection12Stories.m.css";

const FourCollection12Stories = ({ collection }) => {
  const collectionItems = collection.items.filter((item) => item.type === "collection").slice(0, 4);
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const showLoadMoreButton = get(collection, ["associated-metadata", "hide_load_more_button"], null);
  const storiesToLoad = get(collection, ["associated-metadata", "number_of_stories_inside_collection_to_show"], 4);

  return collectionItems.length > 0 ? (
    <div styleName="base" className="four-collection-12-stories" data-testid="4-col-12-story">
      {collectionItems.map((item, index) => (
        <Organism1
          key={index}
          collection={item}
          showCollectionName={showCollectionName}
          showLoadMoreButton={showLoadMoreButton}
          src="four-collection-12-stories"
          updatedFont={true}
          storiesToLoad={storiesToLoad}
          widths={[320]}
        />
      ))}
    </div>
  ) : null;
};

FourCollection12Stories.propTypes = {
  collection: object,
};

export default FourCollection12Stories;
